import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import { NavLink as RouterLink } from 'react-router-dom'

import {
  Button,
  Hidden,
  Link,
  List,
  ListItem,
  makeStyles,
} from '@material-ui/core'

import { Input as InputIcon } from '@material-ui/icons'

import { Permitted } from 'components/Permissions'
import useAuth from 'hooks/useAuth'
import styles from './styles'

const useStyles = makeStyles(styles)

const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref} style={{ flexGrow: 1 }}>
    <RouterLink {...props} />
  </div>
))

const SidebarNav = ({ pages, logout = false, onClose }) => {
  const classes = useStyles()
  const auth = useAuth()

  const handleLogout = () => {
    auth.logout()
  }

  return (
    <List className={classes.root}>
      {pages.map(page => (
        <Permitted tag={page.permission} key={page.title}>
          <ListItem className={classes.item} disableGutters>
            {page.external ? (
              <Button
                className={classes.button}
                onClick={onClose}
                component={Link}
                href={page.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className={classes.icon}>{page.icon}</div>
                {page.title}
              </Button>
            ) : (
              <Button
                activeClassName={classes.active}
                className={classes.button}
                to={page.href}
                onClick={onClose}
                component={CustomRouterLink}
                href={page.href}
              >
                <div className={classes.icon}>{page.icon}</div>
                {page.title}
              </Button>
            )}
          </ListItem>
        </Permitted>
      ))}

      {logout && (
        <Hidden lgUp>
          <ListItem className={classes.item} disableGutters>
            <Button className={classes.button} onClick={handleLogout}>
              <div className={classes.icon}>
                <InputIcon />
              </div>
              Sair
            </Button>
          </ListItem>
        </Hidden>
      )}
    </List>
  )
}

SidebarNav.propTypes = {
  pages: PropTypes.array.isRequired,
  logout: PropTypes.bool,
  onClose: PropTypes.func,
}

export default SidebarNav
